// @ts-nocheck

import React, { useMemo } from 'react';
import styled, { css } from 'styled-components';

import ExtrasIconSvgAsComponent from '../../assets/svg/tab-bar/ExtrasIconSvgAsComponent';
import HomeIconSvgAsComponent from '../../assets/svg/tab-bar/HomeIconSvgAsComponent';
import LiveIconSvgAsComponent from '../../assets/svg/tab-bar/LiveIconSvgAsComponent';
import MyBetsIconSvgAsComponent from '../../assets/svg/tab-bar/MyBetsIconSvgAsComponent';
import BoomNavIconContainer from '../../modules/boom/components/common/BoomNavIcon/BoomNavIconContainer';
import MPIcon from '../../modules/monopoly/components/MPIcon';
import theme from '../../styled-components/dark';
import { DesktopNavigationBarTypes } from '../../types/desktopNavBar';

const getLabelColor = (isHighlight) => {
  if (isHighlight) {
    return theme.DesktopNavigationBarItem.active.color;
  }
  return theme.DesktopNavigationBarItem.passive.color;
};

const Wrapper = styled.div`
  position: relative;

  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  user-select: none;

  padding: 0.75em 2.75em;

  &:after {
    content: '';
    position: absolute;
    bottom: 1px;
    left: 0;
    width: 100%;
    height: 1px;

    transition: background-color 150ms ease-in-out;
    background-color: ${theme.DesktopNavigationBarItem.passive.afterBackgroundColor};
  }

  ${({ $isHighlight }) => {
    if ($isHighlight) {
      return css`
        &:after {
          background-color: ${theme.DesktopNavigationBarItem.active.afterBackgroundColor};
        }
      `;
    }
  }}
`;

const IconWrapper = styled.div`
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;

  height: 3em;

  --BoomNavIcon-width: 100%;
  --BoomNavIcon-height: 100%;

  & svg {
    height: 100%;
    width: auto;
  }
`;

const Label = styled.span`
  width: 100%;
  font-size: 1.25em;

  display: block;
  white-space: nowrap;
  overflow: hidden;

  text-align: center;

  color: ${({ $isHighlight }) => getLabelColor($isHighlight)};
`;

export type NavigationDesktopBarItemProps = {
  id: string;
  label: string;
  isHighlight?: boolean;
  onClick: (...params: unknown) => unknown;
  disableAnimation?: boolean;
};

const NavigationDesktopBarItem = ({
  id,
  label,
  isHighlight = false,
  onClick,
  disableAnimation,
}: NavigationDesktopBarItemProps) => {
  const Icon = useMemo(() => {
    if (id === DesktopNavigationBarTypes.HOME) {
      return <HomeIconSvgAsComponent isActive={isHighlight} />;
    }

    if (id === DesktopNavigationBarTypes.LIVE) {
      return <LiveIconSvgAsComponent isActive={isHighlight} />;
    }

    if (id === DesktopNavigationBarTypes.MY_BETS) {
      return <MyBetsIconSvgAsComponent isActive={isHighlight} />;
    }

    if (id === DesktopNavigationBarTypes.EXTRAS) {
      return <ExtrasIconSvgAsComponent isActive={isHighlight} />;
    }

    if (id === DesktopNavigationBarTypes.MONOPOLY) {
      return <MPIcon disableAnimation={disableAnimation} />;
    }

    if (id === DesktopNavigationBarTypes.BOOM) {
      return <BoomNavIconContainer isActive={isHighlight} disableAnimation={disableAnimation} />;
    }
  }, [id, isHighlight, disableAnimation]);

  return (
    <Wrapper onClick={onClick} $isHighlight={isHighlight}>
      <IconWrapper $isHighlight={isHighlight}>{Icon}</IconWrapper>
      <Label $isHighlight={isHighlight}>{label}</Label>
    </Wrapper>
  );
};

export default NavigationDesktopBarItem;
